import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig.js";
import App from "./App.jsx";
import "antd/dist/reset.css";
import "./index.css";

// If this window is a popup opened by MSAL, just handle the auth response
// and close — don't render the full app (prevents block_nested_popups error).
const isPopup = window.opener && window.opener !== window;

if (isPopup) {
  const msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.initialize().then(() => {
    msalInstance.handleRedirectPromise().catch(() => {});
  });
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
